<template>
  <div class="mob-menu">
    <transition name="fade" mode="out-in">
      <div v-if="isSearchOpen"
           key="search" class="mob-menu__group">
        <div class="mob-menu__head">
          <button type="button"
                  @click="onSearchClose"
                  class="mob-menu__head-top-btn base-btn base-btn--outline-dark base-btn--small">
            <BaseSvg name="ico-arrow-light"
                     width=".4rem"
                     height=".7rem"
                     style="transform: scaleX(-1)"
            />
            <span class="base-btn__text">{{ $tGlobal('To back') }}</span>
          </button>
        </div>
        <HeaderSearch class="mob-menu__search"/>
      </div>

      <div v-else
           key="menu-list"
           class="mob-menu__group">
        <button type="button" class="mob-menu__search-btn" @click="onSearchOpen">
          <BaseSvg name="ico-loupe"/>
          <span>{{ $tHeader('Find a job') }}</span>
        </button>
        <div v-if="!isLogged" class="mob-menu__head">
          <router-link-modified :to="{name: 'auth'}"
                                @click.native="onClose"
                                class="mob-menu__head-top-btn base-btn base-btn--outline-dark base-btn--small">
            <BaseSvg name="ico-user"
                     width="1.5rem"
                     height="1.4rem"/>
            <span class="base-btn__text">
              {{ $tHeader('Login') }}/{{ $tHeader('Registration') }}
            </span>
          </router-link-modified>
          <router-link-modified :to="{name: 'auth-agent'}"
                                @click.native="onClose"
                                class="mob-menu__head-top-btn base-btn base-btn--outline-dark base-btn--small">
            <BaseSvg name="ico-tie"
                     width="0.8rem"
                     height="2rem"/>
            <span class="base-btn__text">
              {{ $tHeader('For agents') }}
            </span>
          </router-link-modified>

          <div class="d-flex">
            <router-link-modified :to="{name: 'for-employers'}"
                                  @click.native="onClose"
                                  class="mob-menu__head-button-row-item base-btn base-btn--blue mr-3">
              {{ $tHeader('find_employees') }}
            </router-link-modified>
            <router-link-modified :to="{name: 'find-vacancy'}"
                                  @click.native="onClose"
                                  class="mob-menu__head-button-row-item _right base-btn  base-btn--green">
              {{ $tHeader('Find vacancy') }}
            </router-link-modified>
          </div>
        </div>

        <MobMenuList :menu="menu"
                     @close="onClose"/>

        <div class="mob-menu__footer">
          <LocaleSelect class="_shadow-full _white _to-up"/>
          <CurrencySelect class="_shadow-full _white _to-up"/>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  // import {http} from '@/axios'
  import {mapState, mapGetters} from 'vuex'
  import {EMPLOYER, EMPLOYEE, PARTNER, MODERATOR, AGENT} from '@/constants/usersTypes'
  import LocaleSelect from './LocaleSelect'
  import CurrencySelect from './CurrencySelect'
  import HeaderSearch from '@/components/HeaderSearch'
  import MobMenuList from '@/components/MobMenuList'

  export default {
    name: 'MobMenu',
    components: {
      MobMenuList,
      HeaderSearch,
      CurrencySelect,
      LocaleSelect
    },
    data() {
      return {
        isSearchOpen: false,
        isAccountMenuOpen: false
      }
    },
    computed: {
      ...mapState('user', [
        'resume',
        'moderatedPassport',
        'hasResponses',
        'receivedNewResumesCount',
      ]),
      ...mapGetters('user', [
        'isLogged',
        'userType',
        'hasInteraction',
      ]),
      menu() {
        const accountPage = {
          name: this.userType === EMPLOYEE ? 'vacancies'
              : this.userType === EMPLOYER ? 'account-vacancies'
                  : 'account-dashboard'
        }

        const result = {
          list: [
            {
              to: {
                name: 'about',
              },
              title: this.$tHeader('About company')
            },
            {
              to: {
                name: 'vacancies'
              },
              title: this.$tHeader('All vacancies')
            },
            // TODO temporary hide services
            // {
            //   to: {
            //     name: 'services'
            //   },
            //   title: this.$tHeader('Services'),
            //   subMenu: this.servicesSubMenu
            // },
            {
              to: {
                name: 'news-page'
              },
              title: this.$tHeader('News')
            },
          ]
        }

        if (this.isLogged) {
          result.list.unshift({
            to: accountPage,
            title: this.$tHeader('My account'),
            subMenu: this.accountSubMenu
          })
        }

        return result
      },
      showPostVacancyButton() {
        const profile = this.$store.state.user.profile
        return profile && profile.user_type === EMPLOYER
      },
      showPostResumeButton() {
        const profile = this.$store.state.user.profile
        return profile && profile.user_type !== EMPLOYER
      },
      servicesSubMenu() {
        return {
          name: this.$tHeader('Services'),
          list: globalConfigs.services_list.map(item => {

            const result = {
              title: item.name,
              ico: item.small_icon,
              disabled: !item.enabled,
              to: item.link ? item.link : {
                name: 'service',
                params: {
                  id: item.slug,
                }
              }
            }

            if (item.childs && item.childs.length) {
              const subMenuList = item.childs.map(child => {
                return {
                  title: child.name,
                  disabled: !child.enabled,
                  to: child.link ? child.link : {
                    name: 'service',
                    params: {
                      id: item.slug,
                      childId: child.slug
                    }
                  }
                }
              })

              result.subMenu = {
                name: item.name,
                list: subMenuList
              }
            }

            return result
          })
        }
      },
      accountSubMenu() {
        const result = {
          name: this.$tHeader('My account'),
          footerLogout: true
        }

        if (this.userType === EMPLOYEE) {
          result.list = [{
            title: this.$tHeader('My vacancies'),
            to: {
              name: 'account-my-vacancies'
            }
          }, {
            title: this.$tHeader('Help'),
            to: {
              name: 'help'
            }
          }]

          if (this.hasInteraction) {
            result.list.unshift({
              title: this.$tHeader('Interaction'),
              to: {
                name: 'account-interaction'
              }
            })
          }

          if (this.resume && this.moderatedPassport) {
            result.list.unshift({
              title: this.$tHeader('My resumes'),
              to: {
                name: 'account-my-resume'
              }
            })
          }
        } else if (this.userType === EMPLOYER) {
          result.list = [{
            title: this.$tHeader('Profile'),
            to: {
              name: 'account-employer-profile-edit',
            }
          }, {
            title: this.$tHeader('Vacancies'),
            to: {
              name: 'account-vacancies'
            }
          }, {
            title: this.$tHeader('My responses'),
            to: {
              name: 'account-vacancies-responses'
            },
            showBadge: () => {
              return !!Number(this.receivedNewResumesCount);
            },
            badge: () => {
              return this.receivedNewResumesCount ? '+ ' + this.receivedNewResumesCount : this.receivedNewResumesCount;
            }
          }]
        } else if (this.userType === PARTNER) {
          result.list = [{
            //   title: this.$tHeader('Dashboard'),
            //   to: {
            //     name: 'account-dashboard',
            //   }
            // }, {
            title: this.$tHeader('Resume base'),
            to: { name: 'account-partner-resumes-base'},
          }, {
            title: this.$tHeader('Affiliate network'),
            to: {name: 'account-partner-partners-network'}
          }, {
              title: this.$tHeader('My responses'),
              to: {name: 'account-vacancies-responses'},
              showBadge: () => {
                return !!Number(this.receivedNewResumesCount);
              },
              badge: () => {
                return this.receivedNewResumesCount ? '+ ' + this.receivedNewResumesCount : this.receivedNewResumesCount;
              }
            }, {
          //   title: this.$tHeader('Balance'),
          //   to: {name: 'account-balance'}
          // },{
            title: this.$tHeader('Statistic'),
            to: {name: 'account-partner-statistic'}
          }, {
            title: this.$tHeader('Useful materials'),
            to: {name: 'account-useful-materials'},
          },]
        } else if (this.userType === MODERATOR) {
          result.list = [{
            title: this.$tHeader('Candidates'),
            to: {name: 'account-moderator-candidates'}
          }, {
            title: this.$tHeader('Marketing'),
            to: {name: 'account-moderator-marketing'}
          }, {
            title: this.$tHeader('Statistic'),
            to: {name: 'account-moderator-statistic'}
          }]
        } else if (this.userType === AGENT) {
          result.list = [{
            title: this.$tHeader('Resume base'),
            to: { name: 'account-agent-resumes-base'},
          }, {
          //   title: this.$tHeader('Balance'),
          //   to: {name: 'account-balance'}
          // }, {
            title: this.$tHeader('Useful materials'),
            to: {name: 'account-useful-materials'},
          }, {
            title: this.$tHeader('My responses'),
            to: {name: 'account-vacancies-responses'},
            showBadge: () => {
              return !!Number(this.receivedNewResumesCount);
            },
            badge: () => {
              return this.receivedNewResumesCount ? '+ ' + this.receivedNewResumesCount : this.receivedNewResumesCount;
            }
          }, {
            title: this.$tHeader('Statistic'),
            to: {name: 'account-agent-statistic'}
          }]
        }

        return result
      }
    },
    methods: {
      onSearchOpen() {
        setTimeout(() => {
          this.isSearchOpen = true
        })
      },
      onSearchClose() {
        setTimeout(() => {
          this.isSearchOpen = false
        })
      },
      onAccountMenuOpen() {
        setTimeout(() => {
          this.isAccountMenuOpen = true
        })
      },
      onAccountMenuClose() {
        setTimeout(() => {
          this.isAccountMenuOpen = false
        })
      },
      onClose() {
        this.$emit('close')
      }
    }
  }
</script>

<style>

</style>
